import React, { FC, ReactElement } from 'react';
import { Tabs } from 'src/common/form/tabs';
import OrganizationLink from 'src/common/OrganizationLink';

interface Props {
  activeTab: string;
  onChangeTab: (newValue: ManagementDropdownTabType) => void;
}

export type ManagementDropdownTabType = 'workspaces' | 'organizations' | 'referrals';

interface ManagementDropdownTabOption {
  value: ManagementDropdownTabType;
  label: ReactElement;
}

const managementDropdownTabOptions: ManagementDropdownTabOption[] = [
  {
    value: 'workspaces',
    label: <div>Workspaces</div>,
  },
  {
    value: 'organizations',
    label: <div>Organizations</div>,
  },
  {
    value: 'referrals',
    label: <div>Referral</div>,
  },
];

const ManagementDropdownTabs: FC<Props> = ({ activeTab, onChangeTab }: Props) => {
  const onChange = (e: any, newValue: string) => onChangeTab(newValue as ManagementDropdownTabType);
  return <Tabs theme='bedrock' value={activeTab} onChange={onChange} options={managementDropdownTabOptions} />;
};

export default ManagementDropdownTabs;
